import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Link } from 'react-router-dom';
export function SignupPage() {
  return <div className="bg-black text-white min-h-screen" data-id="element-355">
      <Header data-id="element-356" />
      <main className="pt-20" data-id="element-357">
        <div className="container mx-auto px-4 py-16" data-id="element-358">
          <div className="max-w-md mx-auto" data-id="element-359">
            <h1 className="text-3xl font-bold mb-6 text-center" data-id="element-360">
              Create Your Account
            </h1>
            <div className="bg-zinc-900 p-8 rounded-lg" data-id="element-361">
              <form className="space-y-6" data-id="element-362">
                <div data-id="element-363">
                  <label htmlFor="name" className="block mb-2 text-gray-300" data-id="element-364">
                    Full Name
                  </label>
                  <input type="text" id="name" className="w-full bg-zinc-800 border border-zinc-700 rounded-md py-3 px-4 text-white focus:outline-none focus:ring-2 focus:ring-red-600" placeholder="John Doe" data-id="element-365" />
                </div>
                <div data-id="element-366">
                  <label htmlFor="email" className="block mb-2 text-gray-300" data-id="element-367">
                    Email Address
                  </label>
                  <input type="email" id="email" className="w-full bg-zinc-800 border border-zinc-700 rounded-md py-3 px-4 text-white focus:outline-none focus:ring-2 focus:ring-red-600" placeholder="john@example.com" data-id="element-368" />
                </div>
                <div data-id="element-369">
                  <label htmlFor="password" className="block mb-2 text-gray-300" data-id="element-370">
                    Password
                  </label>
                  <input type="password" id="password" className="w-full bg-zinc-800 border border-zinc-700 rounded-md py-3 px-4 text-white focus:outline-none focus:ring-2 focus:ring-red-600" placeholder="••••••••" data-id="element-371" />
                </div>
                <div data-id="element-372">
                  <label htmlFor="confirm-password" className="block mb-2 text-gray-300" data-id="element-373">
                    Confirm Password
                  </label>
                  <input type="password" id="confirm-password" className="w-full bg-zinc-800 border border-zinc-700 rounded-md py-3 px-4 text-white focus:outline-none focus:ring-2 focus:ring-red-600" placeholder="••••••••" data-id="element-374" />
                </div>
                <div className="flex items-center" data-id="element-375">
                  <input type="checkbox" id="terms" className="h-4 w-4 border-gray-300 rounded text-red-600 focus:ring-red-600" data-id="element-376" />
                  <label htmlFor="terms" className="ml-2 block text-sm text-gray-300" data-id="element-377">
                    I agree to the{' '}
                    <Link to="/terms" className="text-red-500 hover:text-red-400" data-id="element-378">
                      Terms of Service
                    </Link>{' '}
                    and{' '}
                    <Link to="/privacy" className="text-red-500 hover:text-red-400" data-id="element-379">
                      Privacy Policy
                    </Link>
                  </label>
                </div>
                <button type="submit" className="w-full bg-red-600 text-white py-3 rounded font-medium text-lg hover:bg-red-700 transition-colors" data-id="element-380">
                  Create Account
                </button>
              </form>
              <div className="mt-6 text-center text-gray-400 text-sm" data-id="element-381">
                Already have an account?{' '}
                <Link to="/login" className="text-red-500 hover:text-red-400" data-id="element-382">
                  Log in
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-383" />
    </div>;
}